import { render } from "./update-developmentblock.vue?vue&type=template&id=5c4cfd9e&scoped=true"
import script from "./update-developmentblock.vue?vue&type=script&lang=js"
export * from "./update-developmentblock.vue?vue&type=script&lang=js"

import "./update-developmentblock.vue?vue&type=style&index=0&id=5c4cfd9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4cfd9e"],['__file',"src/components/applications/workorganisation/update-developmentblock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c4cfd9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c4cfd9e', __exports__)) {
    api.reload('5c4cfd9e', __exports__)
  }
  
  module.hot.accept("./update-developmentblock.vue?vue&type=template&id=5c4cfd9e&scoped=true", () => {
    api.rerender('5c4cfd9e', render)
  })

}


export default __exports__